import { Injectable } from '@angular/core';

import { Appointment } from '@paymash/sdk/models/backend/appointment';
import { PublicAppointmentResponseDTO } from '@paymash/sdk/dto/response';
import { ActivatePublicDraftAppointmentRequestDTO } from '@paymash/sdk/dto/request';
import { Customer } from '@models';

@Injectable({
  providedIn: 'root',
})
export class ActivateAppointmentMapper {
  public mapToEntity(dto: PublicAppointmentResponseDTO): Appointment {
    return {
      uuid: dto.uuid,
      appointmentId: dto.appointmentId,
      isCancelAllowedByCustomer: dto.isCancelAllowedByCustomer,
      status: dto.status,
      store: dto.store,
      company: dto.company,
      createdByEmployee: dto.createdByEmployee,
      services: dto.services,
      customer: dto.customer,
      startedAt: dto.startedAt,
      endedAt: dto.endedAt,
      createdAt: dto.createdAt,
      externalNote: dto.externalNote
    };
  }

  public mapToDTO(entity: Customer): ActivatePublicDraftAppointmentRequestDTO {
    return {
      firstName: entity.firstName,
      lastName: entity.lastName,
      email: entity.email,
      phone: entity.phone,
      salutation: entity.salutation,
      comment: entity.comment,
    };
  }
}
